import updateCollectionDateReducer from "./updateCollectionDateReducer";

const collectionDateReducers = {
    updateCollectionDate: updateCollectionDateReducer
};

export default collectionDateReducers;